import startsSvg from '@/assets/image/free-to-pay/trust-pilot-starts.svg';
import { TrustPilotSvg } from '@/assets/image/free-to-pay/trust-pilot-svg';
import { useTranslations } from '@heidi/runtime/i18n';
import Image from 'next/image';

export const TrustPilotReviewMobileTrial = () => {
  const { t } = useTranslations();

  return (
    <div id="trust-pilot-review-mobile-trial" className="mt-auto flex w-full">
      <div className="flex flex-col items-start justify-between gap-y-1">
        <TrustPilotSvg alt="trust-pilot" width={90} height={90} />
        <Image src={startsSvg} alt="starts" width={110} height={110} />
        <p className="text-[8px] text-text-primary-invert newBrand:text-text-primary">
          {t('upgradeProModal.trustScore')} <b>4.8</b> {t('upgradeProModal.reviews')}
        </p>
      </div>
    </div>
  );
};
